import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconArrowLeftWhite from 'components/icons/Slider/iconArrowLeftWhite';
import IconArrowRightWhite from 'components/icons/Slider/iconArrowRightWhite';
import VisuallyHidden from 'components/consumer/VisuallyHidden';
const PDPDimensionShotViewer = t0 => {
  const $ = _c(46);
  let className;
  let currentDimensionShot;
  let hasMultipleDimensionShots;
  let imageProps;
  let onNext;
  let onPrevious;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    const {
      currentDimensionShot: t4,
      hasMultipleDimensionShots: t5,
      selectedDimensionShotIndex,
      totalDimensionShots,
      onPrevious: t6,
      onNext: t7,
      className: t8,
      previousArrowClass: t9,
      nextArrowClass: t10,
      arrowButtonClass: t11,
      ...t12
    } = t0;
    currentDimensionShot = t4;
    hasMultipleDimensionShots = t5;
    onPrevious = t6;
    onNext = t7;
    className = t8;
    t1 = t9;
    t2 = t10;
    t3 = t11;
    imageProps = t12;
    $[0] = t0;
    $[1] = className;
    $[2] = currentDimensionShot;
    $[3] = hasMultipleDimensionShots;
    $[4] = imageProps;
    $[5] = onNext;
    $[6] = onPrevious;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    className = $[1];
    currentDimensionShot = $[2];
    hasMultipleDimensionShots = $[3];
    imageProps = $[4];
    onNext = $[5];
    onPrevious = $[6];
    t1 = $[7];
    t2 = $[8];
    t3 = $[9];
  }
  const previousArrowClass = t1 === undefined ? "-left-3 md:left-4" : t1;
  const nextArrowClass = t2 === undefined ? "-right-3 md:right-4" : t2;
  const arrowButtonClass = t3 === undefined ? "w-10 h-10 bg-white border border-gray-light6 hover:border-brand [&_svg_path]:fill-gray group-hover/SliderButton:[&_svg_path]:fill-[#2f2f2e]" : t3;
  const [imageSrc, setImageSrc] = useState(currentDimensionShot?.src);
  const [hasErrored, setHasErrored] = useState(false);
  let t4;
  if ($[10] !== currentDimensionShot?.src) {
    t4 = () => {
      setImageSrc(currentDimensionShot?.src);
      setHasErrored(false);
    };
    $[10] = currentDimensionShot?.src;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const t5 = currentDimensionShot?.src;
  let t6;
  if ($[12] !== t5) {
    t6 = [t5];
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  useEffect(t4, t6);
  let t7;
  if ($[14] !== currentDimensionShot || $[15] !== hasErrored) {
    t7 = () => {
      if (!hasErrored && currentDimensionShot?.baseUrl) {
        setImageSrc(currentDimensionShot.baseUrl);
        setHasErrored(true);
      }
    };
    $[14] = currentDimensionShot;
    $[15] = hasErrored;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const handleImageError = t7;
  let t8;
  let t9;
  if ($[17] !== hasMultipleDimensionShots || $[18] !== onNext || $[19] !== onPrevious) {
    t8 = () => {
      if (!hasMultipleDimensionShots) {
        return;
      }
      const handleKeyDown = event => {
        if (event.key === "ArrowLeft") {
          onPrevious?.();
        } else {
          if (event.key === "ArrowRight") {
            onNext?.();
          }
        }
      };
      document.addEventListener("keydown", handleKeyDown);
      return () => document.removeEventListener("keydown", handleKeyDown);
    };
    t9 = [hasMultipleDimensionShots, onPrevious, onNext];
    $[17] = hasMultipleDimensionShots;
    $[18] = onNext;
    $[19] = onPrevious;
    $[20] = t8;
    $[21] = t9;
  } else {
    t8 = $[20];
    t9 = $[21];
  }
  useEffect(t8, t9);
  let t10;
  if ($[22] !== imageProps) {
    t10 = imageProps || {};
    $[22] = imageProps;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let lazy;
  let validImgProps;
  if ($[24] !== t10) {
    const {
      enableCrops,
      crops,
      type,
      lazy: t11,
      ...t12
    } = t10;
    lazy = t11;
    validImgProps = t12;
    $[24] = t10;
    $[25] = lazy;
    $[26] = validImgProps;
  } else {
    lazy = $[25];
    validImgProps = $[26];
  }
  let t11;
  if ($[27] !== className) {
    t11 = classNames("relative w-full h-full", className);
    $[27] = className;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== currentDimensionShot || $[30] !== handleImageError || $[31] !== imageSrc || $[32] !== lazy || $[33] !== validImgProps) {
    t12 = currentDimensionShot && <img {...validImgProps} src={imageSrc} alt={`Product dimensions - ${currentDimensionShot.dimensionCode}`} className="h-full w-full object-contain object-center select-none" onError={handleImageError} loading={typeof lazy === "boolean" ? lazy ? "lazy" : "eager" : lazy} />;
    $[29] = currentDimensionShot;
    $[30] = handleImageError;
    $[31] = imageSrc;
    $[32] = lazy;
    $[33] = validImgProps;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== arrowButtonClass || $[36] !== hasMultipleDimensionShots || $[37] !== nextArrowClass || $[38] !== onNext || $[39] !== onPrevious || $[40] !== previousArrowClass) {
    t13 = hasMultipleDimensionShots && <><button type="button" onClick={onPrevious} className={classNames("group/SliderButton absolute top-1/2 -translate-y-1/2 rounded-full flex justify-center items-center transition-all duration-200 [&_svg_path]:transition-all [&_svg_path]:duration-200", arrowButtonClass, previousArrowClass)} aria-label="Previous image"><IconArrowLeftWhite width={20} height={20} /><VisuallyHidden>Previous image</VisuallyHidden></button><button type="button" onClick={onNext} className={classNames("group/SliderButton absolute top-1/2 -translate-y-1/2 rounded-full flex justify-center items-center transition-all duration-200 [&_svg_path]:transition-all [&_svg_path]:duration-200", arrowButtonClass, nextArrowClass)} aria-label="Next image"><IconArrowRightWhite width={20} height={20} /><VisuallyHidden>Next image</VisuallyHidden></button></>;
    $[35] = arrowButtonClass;
    $[36] = hasMultipleDimensionShots;
    $[37] = nextArrowClass;
    $[38] = onNext;
    $[39] = onPrevious;
    $[40] = previousArrowClass;
    $[41] = t13;
  } else {
    t13 = $[41];
  }
  let t14;
  if ($[42] !== t11 || $[43] !== t12 || $[44] !== t13) {
    t14 = <div className={t11}>{t12}{t13}</div>;
    $[42] = t11;
    $[43] = t12;
    $[44] = t13;
    $[45] = t14;
  } else {
    t14 = $[45];
  }
  return t14;
};
PDPDimensionShotViewer.propTypes = {
  currentDimensionShot: PropTypes.shape({
    src: PropTypes.string.isRequired,
    baseUrl: PropTypes.string,
    dimensionCode: PropTypes.string.isRequired
  }),
  hasMultipleDimensionShots: PropTypes.bool,
  selectedDimensionShotIndex: PropTypes.number,
  totalDimensionShots: PropTypes.number,
  onPrevious: PropTypes.func,
  onNext: PropTypes.func,
  className: PropTypes.string,
  previousArrowClass: PropTypes.string,
  nextArrowClass: PropTypes.string,
  arrowButtonClass: PropTypes.string
};
export default PDPDimensionShotViewer;